<template>
  <v-row>
    <v-spacer/>
    <v-col cols="8" class="vert-center">
      
      <div class="aux-pagination-btn">
        <v-btn text>
          <v-icon color="#0000008a" @click="setPage(1)" :disabled="loading">
            mdi-chevron-double-left
          </v-icon>
        </v-btn>
      </div>
      <v-pagination
        v-model="selectedPage"
        :length="totalPages"
        :disabled="loading"
        :total-visible="7"
        @input="pageUpdated"
      ></v-pagination>
      <div class="aux-pagination-btn">
        <v-btn text>
          <v-icon color="#0000008a" @click="setPage(totalPages)" :disabled="loading">
            mdi-chevron-double-right
          </v-icon>
        </v-btn>
      </div>
    </v-col>
    <v-col v-if="showRowOption" cols="1">
      <v-select 
        v-model="selectedRowAmount" 
        label="Rows per page"
        :items="rowOptions"
        :disabled="loading"
        @change="pageUpdated"
      >
      </v-select>
    </v-col>
    <v-col v-if="showPageOption" cols="1" class="pr-6">
      <v-text-field 
        v-model="selectedPage"
        :disabled="loading"
        label="Page"
        type="number"
        :rules="rules"
        @change="pageUpdated"
      />
    </v-col>
  </v-row>
</template>

<script>

import { Logger } from "aws-amplify";
const logger = new Logger("Pagination");

export default {
  name: 'Pagination',
  props: {
    paginationInfo: {
      type: Object,
      required: true
    },

    showRowOption: {
      type: Boolean,
      default: false
    },

    showPageOption: {
      type: Boolean,
      default: false
    },

    loading: {
      type: Boolean,
      default: () => false
    }
  },
  data() {
    return {
      page: 0,
      totalPages: 0,
      rules: [
        v => ( v && v >= 1 ) || `First page cannot be less than 1`,
        v => ( v && v <= this.totalPages ) || `Cannot exceed page number greater than ${this.totalPages}`,
      ],
      rowOptions: [
        20,
        50,
        100,
        200
      ],
      selectedRowAmount: 20
    }
  },
  computed: {
    selectedPage: {
      get() { 
        return parseInt(this.page); 
      },
      set(newVal) { 
        this.page = parseInt(newVal);
      }
    }
  },
  watch: {
    
    
    paginationInfo: {
      deep: true,
      handler(val) {
        this.mapProps(val)
      }
    }
  },
  mounted() {
    window.EventBus.$on('initSearchPage', this.initPage)
    this.mapProps(this.paginationInfo);
  },
  methods: {
    initPage() {
      this.selectedPage = 1;
      this.selectedRowAmount = 10
    },
    setPage(page) {
      if (!page) return;
      this.selectedPage = page;
      this.pageUpdated();
    },
    mapProps(val) {
      logger.debug("map props called", JSON.stringify(val))
      this.page = val.pageNum;
      this.totalPages = val.pageCount
      this.selectedRowAmount = val.rowsPerPage
    },
    pageUpdated() {
      logger.info('updatedPage', this.selectedPage, this.selectedRowAmount)
      if(this.selectedPage >= 1 && this.selectedPage <= this.totalPages) {
        this.$emit('updatedPage', this.selectedPage, this.selectedRowAmount)
      }
      
    }
  }
}
</script>

<style lang="scss" scoped>
  .vert-center {
    align-items: center;
    display: flex;
    justify-content: flex-end;
  }

  .aux-pagination-btn {
    display: flex;
    align-items: center;
    justify-content: center;
    text-align: center;
    padding: 0;
    margin: 0;
  }
</style>